export const getSessionUserId = () => {
  return sessionStorage.getItem('userId');
};

export const setSessionUserId = (id: string) => {
  sessionStorage.setItem('userId', id);
};
